import React from "react";
import { PackageCheck } from "lucide-react";
import { PageHeader } from "../../lib/ui";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../../components/ui/tabs";
import ProductionReceiving from "./ProductionReceiving";
import Receiving from "../Receiving";

export default function ReceivingHub() {
  return (
    <div data-testid="receiving-hub-page">
      <PageHeader title="Penerimaan" subtitle="Receive Goods — penerimaan barang produksi (Order Jahit) & supplier/QC dalam satu tempat">
        <PackageCheck className="w-6 h-6 text-cocoa" />
      </PageHeader>
      <Tabs defaultValue="produksi">
        <TabsList data-testid="rh-tabs" className="mb-2">
          <TabsTrigger value="produksi" data-testid="rh-tab-produksi">Produksi (Order Jahit)</TabsTrigger>
          <TabsTrigger value="supplier" data-testid="rh-tab-supplier">Supplier / QC</TabsTrigger>
        </TabsList>
        <TabsContent value="produksi"><ProductionReceiving /></TabsContent>
        <TabsContent value="supplier"><Receiving /></TabsContent>
      </Tabs>
    </div>
  );
}
